
































import { Component } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AccountToolkitMenu from '@/components/Accounts/Shared/Toolkit/AccountToolkitMenu.vue';
import SimulatedField from '@/components/Accounts/Shared/SimulatedField.vue';
import LendingRevolvingCreditTabs from '@/components/Accounts/LendingAccounts/Tabs/LendingRevolvingCreditTabs.vue';
import LendingFixedTermTabs from '@/components/Accounts/LendingAccounts/Tabs/LendingFixedTermTabs.vue';
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'LendingAccount', components: { Alert, AccountToolkitMenu, SimulatedField, LendingRevolvingCreditTabs, LendingFixedTermTabs }, metaInfo: { title: 'Lending Accounts' } })
export default class extends SaascadaVue {

    ProductSubType = ProductSubType;

    async beforeMount() {
        // Clear the simulation mode when loading a new account to prevent mixing simulations across accounts
        await LendingAccountModule.cancelSimulationMode();
        // Get the new loan account
        await LendingAccountModule.getLendingAccount(this.$route.params.id);
        // Get schedule when loading the overall account because the schedule info is used in lots of places
        await LendingAccountModule.getSchedule();
    }

    get account() {
        return LendingAccountModule.lendingAccount;
    }

    get schedule() {
        return LendingAccountModule.schedule;
    }

    get simulation() {
        return LendingAccountModule.simulation;
    }

    get loading() {
        return LendingAccountModule.loadingLendingAccount;
    }

}
